import ShowcaseDtcCustomCta from "@zillow/custom-dtc-cta";
import DtsPropertyBlock from "@zillow/custom-dts-block";
import DtsCustomCta from "@zillow/custom-dts-cta";
import { PriceMyRentalSearchModuleBlock, PostAListingSearchModuleBlock, LandingPageCTABlock } from "@zg-rentals/zrm-marketing-components";
import { AgentSearchBlock, AmortizationBlock, CashOutRefinanceCalculatorBlock, ClosingCostCalculatorBlock, DownPaymentCalculatorBlock, DTICalculatorBlock, FHACalculatorBlock, FSBOPropertySearchBlock, GoogleFormBlock, HelocCalculatorBlock, HomeSaleProceedsCalculatorBlock, HubspotEmbedBlock, HubspotFormBlock, LoanComparisonBlock, MortgageCalculatorBlock, MortgageRateTrendsBlock, MortgageRatesSummaryBlock, ProratedRentCalculatorBlock, PropertyReportTransparencyBlock, RentAffordabilityCalculatorBlock, RentalRoiCalculatorBlock, RiddleEmbedBlock, VALoanCalculatorBlock, MortgageQuestionnareBlock, RefinanceCalculatorBlock } from "@zillow/zrs-cms";
import PricingWebsiteDataBlockExport from "../blocks/PricingWebsiteData/PricingWebsiteData.esm.js";
import { frontierBlocks } from "../frontier/init.esm.js";
import BlockAffordabilityCalculator from "../blocks/AffordabilityCalculator/AffordabilityCalculatorBlock.esm.js";
import BlockAffordabilityCalculatorV2 from "../blocks/AffordabilityCalculatorV2/AffordabilityCalculatorV2.esm.js";
import BlockApexField from "../blocks/ApexField/ApexField.esm.js";
import BlockApexFields from "../blocks/ApexFields/ApexFields.esm.js";
import BlockApexForm from "../blocks/ApexForm/ApexForm.esm.js";
import BlockApexSubmit from "../blocks/ApexSubmit/ApexSubmit.esm.js";
import BlockApexSuccess from "../blocks/ApexSuccess/ApexSuccess.esm.js";
import Button from "../blocks/Button/Button.esm.js";
import BlockButtonGroup from "../blocks/ButtonGroup/ButtonGroup.esm.js";
import BlockCard from "../blocks/Card/Card.esm.js";
import BlockCarousel$1 from "../blocks/CarouselItem/Carousel.esm.js";
import BlockCarousel from "../blocks/Carousel/Carousel.esm.js";
import BlockCode from "../blocks/Code/Code.esm.js";
import BlockDivider from "../blocks/Divider/Divider.esm.js";
import BlockEmbed from "../blocks/Embed/Embed.esm.js";
import BlockFAQ from "../blocks/FAQ/FAQ.esm.js";
import FAQItem from "../blocks/FAQItem/FAQItem.esm.js";
import BlockGridContent from "../blocks/GridContent/GridContent.esm.js";
import BlockGridLayout from "../blocks/GridLayout/GridLayout.esm.js";
import BlockGroup from "../blocks/Group/Group.esm.js";
import BlockHeading from "../blocks/Heading/Heading.esm.js";
import BlockHmimhwPropertySearch from "../blocks/HmimhwPropertySearch/HmimhwPropertySearch.esm.js";
import Image from "../blocks/Image/Image.esm.js";
import BlockList from "../blocks/List/List.esm.js";
import BlockListItem from "../blocks/ListItem/ListItem.esm.js";
import BlockMediaObject from "../blocks/MediaObject/MediaObject.esm.js";
import BlockMediaStepper from "../blocks/MediaStepper/MediaStepperBlock.esm.js";
import BlockModalDialog from "../blocks/ModalDialog/ModalDialog.esm.js";
import BlockMilitaryInstallationHomeSearch from "../blocks/MilitaryInstallationHomeSearch/MilitaryInstallationHomeSearch.esm.js";
import BlockMilitaryRentCalculator from "../blocks/MilitaryRentCalculator/MilitaryRentCalculator.esm.js";
import BlockMortgageRatesTable from "../blocks/MortgageRatesTable/MortgageRatesTable.esm.js";
import BlockParagraph from "../blocks/Paragraph/Paragraph.esm.js";
import Picture from "../blocks/Picture/Picture.esm.js";
import Posts from "../blocks/Posts/Posts.esm.js";
import BlockPropertySearch from "../blocks/PropertySearch/PropertySearch.esm.js";
import BlockPropertyTaxCalculator from "../blocks/PropertyTaxCalculator/PropertyTaxCalculator.esm.js";
import Quote from "../blocks/Quote/Quote.esm.js";
import BlockSEOFooter from "../blocks/SEOFooter/SEOFooter.esm.js";
import BlockSimonField from "../blocks/SimonField/SimonField.esm.js";
import BlockSimonFields from "../blocks/SimonFields/SimonFields.esm.js";
import BlockSimonForm from "../blocks/SimonForm/SimonForm.esm.js";
import BlockSimonSuccess from "../blocks/SimonSuccess/SimonSuccess.esm.js";
import BlockSpacer from "../blocks/Spacer/Spacer.esm.js";
import BlockTable from "../blocks/Table/Table.esm.js";
import TabsBlock from "../blocks/Tabs/Tabs.esm.js";
import BlockTaxComparisonTable from "../blocks/TaxComparisonTable/TaxComparisonTable.esm.js";
import BlockUpsell from "../blocks/Upsell/Upsell.esm.js";
import BlockVideo from "../blocks/Video/Video.esm.js";
import BlockVimeo from "../blocks/Vimeo/Vimeo.esm.js";
import WPBlock from "../blocks/WPBlock/WPBlock.esm.js";
import WPList from "../blocks/WPList/index.esm.js";
import BlockYoutube from "../blocks/Youtube/Youtube.esm.js";
import BlockZOAddressSearch from "../blocks/ZOAddressSearch/ZOAddressSearch.esm.js";
const CMS_BLOCKS = [AgentSearchBlock, AmortizationBlock, CashOutRefinanceCalculatorBlock, ClosingCostCalculatorBlock, DownPaymentCalculatorBlock, DTICalculatorBlock, DtsCustomCta, DtsPropertyBlock, FHACalculatorBlock, FSBOPropertySearchBlock, GoogleFormBlock, HelocCalculatorBlock, HomeSaleProceedsCalculatorBlock, HubspotEmbedBlock, HubspotFormBlock, LoanComparisonBlock, MortgageCalculatorBlock, MortgageRateTrendsBlock, MortgageRatesSummaryBlock, ProratedRentCalculatorBlock, PropertyReportTransparencyBlock, PricingWebsiteDataBlockExport, RentAffordabilityCalculatorBlock, RentalRoiCalculatorBlock, RiddleEmbedBlock, ShowcaseDtcCustomCta, VALoanCalculatorBlock, MortgageQuestionnareBlock, RefinanceCalculatorBlock, PriceMyRentalSearchModuleBlock, PostAListingSearchModuleBlock, LandingPageCTABlock];
const SYNCHRONOUS_BLOCKS_BASE = {
  "constellation/affordability-calculator": BlockAffordabilityCalculator,
  "constellation/affordability-calculator-v2": BlockAffordabilityCalculatorV2,
  "constellation/apex-field": BlockApexField,
  "constellation/apex-fields": BlockApexFields,
  "constellation/apex-form": BlockApexForm,
  "constellation/apex-submit": BlockApexSubmit,
  "constellation/apex-success": BlockApexSuccess,
  "constellation/button": Button,
  "constellation/button-group": BlockButtonGroup,
  "constellation/card": BlockCard,
  "constellation/carousel": BlockCarousel$1,
  "constellation/carousel-v2": BlockCarousel,
  "constellation/code": BlockCode,
  "constellation/divider": BlockDivider,
  "constellation/embed": BlockEmbed,
  "constellation/faq": BlockFAQ,
  "constellation/faq-item": FAQItem,
  "constellation/grid-content": BlockGridContent,
  "constellation/grid-layout": BlockGridLayout,
  "constellation/group": BlockGroup,
  "constellation/heading": BlockHeading,
  "constellation/hmimhw-property-search": BlockHmimhwPropertySearch,
  "constellation/image": Image,
  "constellation/list": BlockList,
  "constellation/list-item": BlockListItem,
  "constellation/media-object": BlockMediaObject,
  "constellation/media-stepper": BlockMediaStepper,
  "constellation/modal-dialog": BlockModalDialog,
  "constellation/military-installation-home-search": BlockMilitaryInstallationHomeSearch,
  "constellation/military-rent-calculator": BlockMilitaryRentCalculator,
  "constellation/mortgage-rates-table": BlockMortgageRatesTable,
  "constellation/paragraph": BlockParagraph,
  "constellation/picture": Picture,
  "constellation/posts": Posts,
  // TODO: Posts can't be dynamic because of getBlocksData when we updated to next 13 we can fix this.
  "constellation/property-search": BlockPropertySearch,
  "constellation/property-tax-calculator": BlockPropertyTaxCalculator,
  "constellation/quote": Quote,
  "constellation/seo-footer": BlockSEOFooter,
  "constellation/simon-field": BlockSimonField,
  "constellation/simon-fields": BlockSimonFields,
  "constellation/simon-form": BlockSimonForm,
  "constellation/simon-success": BlockSimonSuccess,
  "constellation/spacer": BlockSpacer,
  "constellation/table": BlockTable,
  "constellation/tabs": TabsBlock,
  "constellation/tax-comparison-table": BlockTaxComparisonTable,
  "constellation/upsell": BlockUpsell,
  "constellation/video": BlockVideo,
  "constellation/vimeo": BlockVimeo,
  "constellation/youtube": BlockYoutube,
  "constellation/zo-address-search": BlockZOAddressSearch,
  "core/block": WPBlock,
  "core/list": WPList
};
const CMS_BLOCKS_MAPPING = CMS_BLOCKS.reduce((obj, block, index) => {
  var _a;
  if (!block) {
    throw new Error(`No block found for index ${index}`);
  }
  if ((_a = block.metadata) == null ? void 0 : _a.name) {
    obj[block.metadata.name] = block;
  } else {
    console.error("No name found for block", block, 'Check if "name" is set in the block metadata');
  }
  return obj;
}, {});
const BLOCK_MAPPING = {
  ...SYNCHRONOUS_BLOCKS_BASE,
  ...frontierBlocks,
  // ← Components only, no metadata needed for frontend
  ...CMS_BLOCKS_MAPPING
};
function getSynchronousBlocks() {
  return {
    ...SYNCHRONOUS_BLOCKS_BASE,
    ...CMS_BLOCKS_MAPPING
  };
}
export {
  BLOCK_MAPPING,
  BLOCK_MAPPING as default,
  getSynchronousBlocks
};
